import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setProductionOperations = (state, { productionOperationsData }) => {
  if (!productionOperationsData) return state;
  return state.merge({ productionOperationsData });
};

const setProductionOperationsLoaderStatus = (state, { productionOperationsLoader }) => {
  return state.merge({ productionOperationsLoader });
};

const setProductionFilter = (state, { addProduction }) => {
  return state.merge({ addProduction });
};

const setShiftProduction = (state, { shiftProductionData }) => {
  if (!shiftProductionData) return state;
  return state.merge({ shiftProductionData });
};
const setOeesProductionDates = (state, { productionData }) => {
  if (!productionData) return state;
  return state.merge({ productionData });
};

const setProductionHours = (state, { productionHoursData }) => {
  if (!productionHoursData) return state;
  return state.merge({ productionHoursData });
};

const setProductionShifts = (state, { productionShiftsData }) => {
  if (!productionShiftsData) return state;
  return state.merge({ productionShiftsData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_PRODUCTION_OPERATIONS,
    actionFunction: setProductionOperations,
  },
  {
    actionType: ActionTypes.SET_PRODUCTION_OPERATIONS_LOADER_STATUS,
    actionFunction: setProductionOperationsLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_PRODUCTION_FILTER,
    actionFunction: setProductionFilter,
  },
  {
    actionType: ActionTypes.SET_SHIFT_PRDUCTION,
    actionFunction: setShiftProduction,
  },
  {
    actionType: ActionTypes.SET_OEE_PRODUCTION_DATES,
    actionFunction: setOeesProductionDates,
  },
  {
    actionType: ActionTypes.SET_PRODUCTION_HOURS,
    actionFunction: setProductionHours,
  },
  {
    actionType: ActionTypes.SET_PRODUCTION_SHIFTS,
    actionFunction: setProductionShifts,
  },
];
